<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>待审核</h6>
      <!-- <el-button class="titBtn" type="warning" icon="el-icon-delete" @click="deleteClick()">删除</el-button> -->
      <!-- <div class="import-s">
        <p class>
          <span class="el-icon-upload2"></span>导入
        </p>
        <input type="file" @change="xzdata($event)" />
      </div> -->
      <!-- <el-button class="titBtn" type="success" icon="el-icon-download" @click="download">模板下载</el-button> -->
      <el-button class="titBtn" type="warning" icon="el-icon-document-delete" @click="rejecting">驳回</el-button>
      <el-button class="titBtn" type="primary" icon="el-icon-document" @click="auditing">审核</el-button>
      <el-button class="titBtn" type="success" icon="el-icon-search" @click="search">搜索</el-button>
      <addressTree @obj="objdata"></addressTree>
      <el-select multiple placeholder="请选择类型" v-model="ydbType" @change="ydbTypeChange" class="titBtn"
        style="width: 260px;" clearable>
        <el-option label="大型坝" value="大型"></el-option>
        <el-option label="中型坝" value="中型"></el-option>
        <el-option label="小型坝" value="小型"></el-option>
      </el-select>

      <el-select v-model="county" placeholder="请选择县" class="titBtn" clearable>
        <el-option v-for="item in xianData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>

      <el-select v-model="city" placeholder="请选择市" @change="shiChange" class="titBtn" clearable>
        <el-option v-for="item in shiData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>
      <el-select v-model="province" placeholder="请选择省" @change="shengChange" class="titBtn" clearable>
        <el-option v-for="item in shengData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>
      <el-checkbox-group v-model="checkList" @change="checklistChange">
        <el-checkbox label="登记"></el-checkbox>
        <el-checkbox label="编辑"></el-checkbox>
        <el-checkbox label="销号"></el-checkbox>
      </el-checkbox-group>
    </div>

    <!--<div class="trees">
			<el-tree :default-expand-all='true' :expand-on-click-node="false" ref="tree" class="treeClass" :filter-node-method="filterNode" :data="treedata" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
		</div>-->

    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange"
        :header-cell-style="{ background: 'rgba(49,130,222,0.1)' }" :data="tabledata" :height="tableHeight" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" align='center' width="45" label="序号"></el-table-column>
        <el-table-column prop="ydbLx" align='center' label="审核类型">
          <template slot-scope="scope">
            <p v-if="tabledata[scope.$index].ydbLx == '销号'" style="color: red">{{ tabledata[scope.$index].ydbLx }}</p>
            <p v-if="tabledata[scope.$index].ydbLx == '编辑'" style="color: orange">{{ tabledata[scope.$index].ydbLx }}
            </p>
            <p v-if="tabledata[scope.$index].ydbLx == '登记'" style="color: green">{{ tabledata[scope.$index].ydbLx }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
        <el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
        <el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
        <el-table-column prop="ydbXiang" align='center' label="乡"></el-table-column>
        <el-table-column prop="ydbCun" align='center' label="村"></el-table-column>
        <el-table-column prop="ydbName" align='center' label="淤地坝名称"></el-table-column>
        <el-table-column prop="ydbCode" align='center' label="淤地坝编码"></el-table-column>
        <el-table-column prop="ydbSfwggb" align='center' label="淤地坝类型"></el-table-column>
        <el-table-column prop="ydbDshrq" align='center' label="提交审核日期"></el-table-column>
        <el-table-column prop="operName" align='center' label="提交人"></el-table-column>
        <el-table-column prop="ydbPdfName" align='center' label="销号凭证">

      <template #default="scope">
        <span @click="handleRowClick(scope.row.attach)" class="table-btn btn-handle"><i class="ri-eye-line"></i><a :style="{ color: 'blue' }">{{getFileName(scope.row.attach)}}</a></span>
        <!-- <span @click="handleDownLoadClick(scope.row)" class="table-btn btn-handle"><i class="ri-download-2-line"></i>下载</span> -->
      </template>
    </el-table-column>
        <!-- <el-table-column prop="ydbStatus" align='center' label="审核状态">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbStatus" placeholder="请选择类型">
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="驳回" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column> -->
        <el-table-column prop="" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <!--<el-tooltip class="item" effect="dark" content="下载" placement="top-start">
							<el-button type="primary" icon="el-icon-download" class="tableedit" round></el-button>
						</el-tooltip>-->
            <!--<el-tooltip class="item" effect="dark" content="预览" placement="top-start">
							<el-button type="success" icon="el-icon-view" class="tableedit" round></el-button>
						</el-tooltip>-->
            <!-- <el-button type="primary" icon="el-icon-download" class="tableedit" round
              @click='downloadrow(scope.$index,scope.row)'></el-button> -->
            <!-- <el-button type="success" icon="el-icon-edit" circle @click="edit(scope.$index,scope.row)"
              class="btnmargin"></el-button> -->
            <el-tooltip content="查看" placement="top" effect="dark">
              <el-button type="primary" icon="el-icon-view" circle @click="See(scope.$index, scope.row)"
                class="btnmargin"></el-button>
            </el-tooltip>

            <!-- <el-button type="warning" icon="el-icon-delete" circle @click="deletes(scope.$index,scope.row)" class="btnmargin"></el-button> -->
            <el-tooltip content="数据比对" placement="top" effect="dark">
              <el-button type="primary" icon="el-icon-refresh" circle
                @click="compare(scope.$index, scope.row)"></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>

    </div>

    <el-dialog
      title="预览"
      :visible.sync="PreviewDialogVisible"
      append-to-body
      width="70%"
      :style="{ 'position': 'fixed'}"
      center
      :before-close="closePdf"
    >
      <div>
        <iframe ref="pdfIframe" :src="pdfSrc" width="100%" height="600px" id="iframe"></iframe>
      </div>
    </el-dialog>

    <div class="fye">
      <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums">
      </pagintion>
    </div>

    <registerXzpopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel">
    </registerXzpopup>

    <comparepopup v-if="comparedialogVisible == true" :ydbInfo="ydbInfo" @getcancel="cancelCompare">
    </comparepopup>

  </div>
</template>

<script>
import addressTree from '@/components/mangement/addressTree.vue'
import pagintion from '@/components/mangement/pagintion.vue'

import registerXzpopup from '../popup/registerXzpopup.vue'
import comparepopup from '../popup/comparepopup.vue'
import Url from '@/common/js/Url.js'
import axios from 'axios'
import {
  selectPreApproveYdb,
  ydbdeleteYdbInfo,
  approvedYdb,
  rejectedYdb,
  initRegion,
  getRegion

} from '@/api/api.js'
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 180,
      tabledata: [],
      total: null,
      pageSize: 20, // 每页多少条数据分页
      pageNum: 1, // 当前页
      pageNums: null,
      multipleSelection: [],
      dialogVisible: false,
      Addsid: [],
      PreviewDialogVisible: false,
      objdata1: null,
      checkList: ['登记', '编辑', '销号'],
      ydbLx: '',
      comparedialogVisible: false,
      ydbInfo: null,
      shengData: null,
      shiData: null,
      xianData: null,
      ydbType: [],
      province: '',
      city: '',
      county: ''
    }
  },

  computed:{

  },


  components: {
    addressTree,
    pagintion,
    registerXzpopup,
    comparepopup
  },
  created() {
    // 执行initRegion方法，通过接口获取省
    initRegion().then((res) => {
      this.shengData = res.sheng
      this.shiData = res.shi
      this.xianData = res.xian
    })
  },
  mounted() {
    const params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum,
      ydbName: this.objdata1,
      ydbLx: this.checkList.toString()
    }
    this.list(params)
  },
  methods: {
    Bjadddata() {
      this.dialogVisible = false
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    Getcancel() {
      this.dialogVisible = false
    },



    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    edit(index, row) {
      // this.Addsid = [row]
      this.Addsid = ['bj', row]
      this.dialogVisible = true
    },
    See(index, row) {
      this.Addsid = ['ck', row]
      this.dialogVisible = true
    },
    downloadrow(index, row) {
      window.location.href = '/userApi/ydb/basic/downYdbInfo?id=' + row.id
    },
    treeClose() {
      this.objdata1 = null
      this.total = null
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.ydbLx,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    search() {
      this.tabledata = []
      this.total = null
      this.pageSize = 20
      this.pageNum = 1
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },

    objdata(data) {
      this.objdata1 = data
    },
    DsyData(data) { // 多少页
      this.pageNum = data.dsy
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    DstData(data) { // 多少条
      this.pageSize = data.dst
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbLx: this.checkList.toString(),
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },
    download() {
      window.location.href = '/userApi/ydb/basic/export'
    },

    list(params) {
      this.tabledata = []
      selectPreApproveYdb(params).then((res) => {
        // console.log(res.data)
        this.total = res.total
        this.tabledata = res.data
      })
    },
    deleteClick() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要删除的数据！',
          type: 'success'
        })
      } else {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            const ids = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id)
            }

            ydbdeleteYdbInfo(ids).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: '提示',
                  message: '删除成功！共删除' + res.data + '条数据',
                  type: 'success'
                })
                const params = {
                  pageSize: this.pageSize,
                  pageNum: this.pageNum,
                  ydbName: this.objdata1,
                  ydbLx: this.ydbLx
                }
                this.list(params)
              } else {
                this.$notify({
                  title: '提示',
                  message: '删除失败！',
                  type: 'success'
                })
              }
            })
          }
        }).catch(() => {

        })
      }
    },

    xzdata(e) {
      const file = e.target.files[0]
      const filename = file.name.split('.')[
        file.name.split('.').length - 1
      ]

      const filenames = file.name
      const fileSize = file.size / 1024 / 1024 < 1000000

      if (fileSize) {
        if (filename != 'xlsx') {
          this.$notify({
            title: '提示',
            message: '请选择xls文件',
            type: 'success'
          })
          e.target.value = null
        } else {
          const formData = new FormData()
          formData.append('file', file)
          /* formData.append("importFile", file);
            formData.append("no", this.treeno);
            formData.append("proId", this.proID); */
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data'
              // "login-token": this.$store.state.logintoken,
            }
          } // 添加请求头

          axios.post('/importfile/ydb/basic/import', formData, config).then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: '提示',
                message: res.data.message,
                type: 'success'
              })
              const params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1,
                ydbLx: this.ydbLx
              }
              this.list(params)
              e.target.value = null
            } else {
              this.$notify({
                title: '提示',
                message: res.data.message,
                type: 'warning'
              })
            }
          }).catch((err) => { })
        }
      } else {
        this.$message({
          message: '文件不能大于10M',
          type: 'success'
        })
        e.target.value = null
      }
    },

    // 提交审核
    auditing() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要审核通过的数据！',
          type: 'warning'
        })
      } else {
        this.$confirm('此操作将审核通过, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            const ids = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.tabledata = this.tabledata.filter(function (item) {
              return ids.indexOf(item.id) < 0
            })
            approvedYdb(this.multipleSelection).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: '提示',
                  message: '审核成功！',
                  type: 'success'
                })
                // let params = {
                //   pageSize: this.pageSize,
                //   pageNum: this.pageNum,
                //   ydbName: this.objdata1
                // };
                // this.list(params);
              } else {
                this.$notify({
                  title: '提示',
                  message: '审核失败！',
                  type: 'error'
                })
              }
            })
          }
        }).catch(() => {
        })
      }
    },

    // 驳回操作
    rejecting() {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要驳回的数据！',
          type: 'warning'
        })
      } else {
        this.$confirm('此操作将驳回审核, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            const ids = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.tabledata = this.tabledata.filter(function (item) {
              return ids.indexOf(item.id) < 0
            })
            rejectedYdb(this.multipleSelection).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: '提示',
                  message: '驳回成功！',
                  type: 'success'
                })
                // let params = {
                //   pageSize: this.pageSize,
                //   pageNum: this.pageNum,
                //   ydbName: this.objdata1
                // };
                // this.list(params);
              } else {
                this.$notify({
                  title: '提示',
                  message: '驳回失败！',
                  type: 'error'
                })
              }
            })
          }
        }).catch(() => {
        })
      }
    },

    // 审核类型切换事件
    checklistChange() {
      // console.log(this.checkList)
      if (this.checkList.length == 0) {
        this.ydbLx = ''
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1,
          ydbLx: this.ydbLx,
          ydbShengCode: this.province == '' ? null : this.province,
          ydbShiCode: this.city == '' ? null : this.city,
          ydbXianCode: this.county == '' ? null : this.county,
          ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
        }
        this.list(params)
      } else {
        this.ydbLx = this.checkList.toString()
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbName: this.objdata1,
          ydbLx: this.ydbLx,
          ydbShengCode: this.province == '' ? null : this.province,
          ydbShiCode: this.city == '' ? null : this.city,
          ydbXianCode: this.county == '' ? null : this.county,
          ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
        }
        this.list(params)
      }
    },
    // 数据比对
    compare(index, row) {
      this.ydbInfo = row;
      this.comparedialogVisible = true;
    },
    cancelCompare() {
      this.comparedialogVisible = false
    },
    shengChange() {
      if (Array.isArray(this.shiData) && this.shiData.length != 0) {
        this.city = ''
        this.county = ''
        this.shiData = null
        this.xianData = null
      }
      const params = {
        regionCode: this.province
      }
      getRegion(params).then((res) => {
        this.shiData = res.data
      })
    },
    shiChange() {
      if (Array.isArray(this.xianData) && this.xianData.length != 0) {
        this.county = ''
        this.xianData = null
      }
      const params = {
        regionCode: this.city
      }
      getRegion(params).then((res) => {
        this.xianData = res.data
      })
    },
    ydbTypeChange(value) {
      this.ydbType = value
    },
    closePdf(){
      this.pdfSrc = '';
      this.PreviewDialogVisible=false;
    },

    handleRowClick(row) {
      const fileObj = JSON.parse(row)

      const fileName = fileObj.fileName
      // 构建请求URL，包含Access-Token
      const url = `/userApi/minio/viewFile/${fileName}`;
      // 构建请求头，包含Content-Type和Access-Token
      const headers = {
        "Access-Token": this.$store.state.token
      };

      fetch(url, {
          method: 'GET',
          headers: headers,
        })
          .then(response => response.blob())
          .then(blob2 => {
            if (blob2 instanceof Blob) {
              // 创建一个a标签用于下载
              const blob = new Blob([blob2], { type: "application/pdf" });
              this.pdfSrc = window.URL.createObjectURL(blob);
              this.$nextTick(() => {
                this.PreviewDialogVisible = true;
              });
            } else {
              // 如果响应不是文件流，处理错误
              console.error('Response is not a file stream');
            }
          })
          .catch(error => console.error('下载失败：', error));
    },
    getFileName(data){
      if(data){
        let fileObj = JSON.parse(data)
        return fileObj.filePath
      }


    }
  }
}
</script>

<style scoped>
  @import url('../../../common/css/mangementall.css');

  .zblxtree {
    width: 230px;
    height: calc(100% - 80px);
    height: -webkit-calc(100% - 80px);
    height: -moz-calc(100% - 80px);
    background: #f7f7f7;
    border-radius: 6px;
    float: left;
    overflow: auto;
    padding: 15px;
  }

  .zblxtreeSty {
    background: #f7f7f7;
    border-radius: 6px;
  }

  .tablelist {
    width: 100%;
    height: calc(100% - 50px);
    height: -webkit-calc(100% - 50px);
    height: -moz-calc(100% - 50px);
    float: right;
    position: relative;
  }

  .tablelistbox {
    width: 100%;
    heigt: 100%;
  }

  .clsjTis {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    width: 335px;
    height: 210px;
    border: 1px solid #cccccc;
    background: #f7f7f7;
    border-radius: 6px;
    font-size: 16px;
  }

  .ycllxname {
    float: left;
    line-height: 30px;
    font-size: 14px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .cllx-select {
    float: left;
    margin-top: 10px;
    width: 230px;
  }

  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .zzct {
    font-size: 20px;
    margin-right: 10px;
  }

  .import-s {
    float: right;
    position: relative;
    width: 100px;
    height: 28px;
    background: #409eff;
    margin-right: 10px;
    border-radius: 4px;
    margin-top: 11px;
    overflow: hidden;
  }

  .import-s p {
    position: absolute;
    width: 100%;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
  }

  .import-s p span {
    margin-right: 5px;
  }

  .import-s input {
    width: 100%;
    height: 28px;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  >>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;
    font-size: 14px;
  }

  >>>.el-checkbox-group {
    line-height: 50px;
    float: right;
    padding-right: 20px;
  }
</style>
